import React, { useState, useEffect } from "react";
import axios from "axios";
import { MdClose } from "react-icons/md";
import toast from "react-hot-toast";

const StockChangeModal = ({ isOpen, onClose, cHngModalData, getAllProducts }) => {
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && cHngModalData?.prod_status) {
      setSelectedStatus(cHngModalData.prod_status);
    }
  }, [isOpen, cHngModalData]);

  if (!isOpen || !cHngModalData) return null;

  const handleChangeStock = async () => {
    if (!selectedStatus) {
      toast.error("Please select a stock status");
      return;
    }

    setLoading(true);

    try {
      await axios.patch(
        `${process.env.REACT_APP_API_URL}/products/change-stock-status/${cHngModalData?.prod_id}`,
        { stock_status: selectedStatus }
      );

      toast.success("Stock status updated successfully!");

      await getAllProducts();
      onClose();
    } catch (error) {
      console.error("Error updating stock:", error);

      toast.error(
        error.response?.data?.message ||
          "Failed to update stock status. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const statuses = [
    { value: "active", label: "In Stock", color: "text-green-600" },
    { value: "inactive", label: "Inactive", color: "text-gray-600" },
    { value: "out of stock", label: "Out of Stock", color: "text-red-600" },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md relative animate-fade-in">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          <MdClose size={22} />
        </button>

        <h2 className="text-xl font-semibold text-gray-800 text-center mb-3">
          Change Stock Status
        </h2>

        <p className="text-center text-gray-600 mb-4">
          Current Status:{" "}
          <span className="font-semibold text-blue-600">
            {cHngModalData?.prod_status}
          </span>
        </p>

        <div className="space-y-3 mb-5">
          {statuses.map((status) => (
            <label
              key={status.value}
              className="flex items-center space-x-3 border rounded-lg px-3 py-2 hover:bg-gray-50 cursor-pointer"
            >
              <input
                type="radio"
                name="stockStatus"
                value={status.value}
                checked={selectedStatus === status.value}
                onChange={(e) => setSelectedStatus(e.target.value)}
              />
              <span className={`font-medium ${status.color}`}>
                {status.label}
              </span>
            </label>
          ))}
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
          >
            Cancel
          </button>

          <button
            onClick={handleChangeStock}
            disabled={loading}
            className="px-5 py-2 rounded-lg bg-[#b07d17] text-white hover:bg-[#8c6312] disabled:bg-gray-400"
          >
            {loading ? "Updating..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StockChangeModal;
